exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".color[data-v-76e91479]{width:40px;height:40px}.color.active[data-v-76e91479]{border-color:#ffba00}.color-inside[data-v-76e91479]{width:34px;height:34px;left:50%;top:50%;transform:translate(-50%, -50%)}\n", ""]);

// exports
